import { KeycloakTokenParsed } from "keycloak-js";

export interface User {
    username: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    roles?: string[];
    authenticated?: boolean;
}

export class User {
    
    constructor(username: string, firstName?: string, lastName?: string, email?: string, roles?: string[]) {
        this.username = username;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.roles = roles;
        this.authenticated = true;
    }
}

export function getUserFromToken(token?: KeycloakTokenParsed): User {
    if (!token) {
        return {} as User;
    }
    const user = new User(token.preferred_username, token.given_name, token.family_name, token.email, token.realm_access?.roles);
    return user;
}